import React, { memo } from 'react';
import {
	useAdjustmentsEnabled,
	isFieldTypeSupported,
} from '@atlassian/ui-modifications-core/controllers';
import { getNormalizedType } from '@atlassian/jira-ui-modifications-common/src/common/utils/common/utils/get-normalized-field-type/index.tsx';

import { GIC_VIEW_TYPE } from '../../common/constants/index.tsx';
import { EnabledFieldDecorator } from './enabled-field-decorator/index.tsx';
import type {
	DecoratedField,
	EnabledFieldDecoratorProps,
} from './enabled-field-decorator/types.tsx';

// eslint-disable-next-line jira/export/restrict-types-re-export
export type ComponentProps = DecoratedField;
export type FieldDecoratorAsyncProps<T extends ComponentProps> = EnabledFieldDecoratorProps<T>;

const FieldDecoratorAsyncNoMemo = <T extends ComponentProps>({
	Component,
	componentProps,
}: FieldDecoratorAsyncProps<T>): React.JSX.Element => {
	const adjustmentsAreEnabled = useAdjustmentsEnabled();

	const undecoratedComponent = <Component {...componentProps} />;

	const normalizedType = getNormalizedType(componentProps.fieldType, componentProps.gqlType);

	// Render FieldDecorator only when field type is supported
	// and adjustments are enabled
	if (isFieldTypeSupported(GIC_VIEW_TYPE, normalizedType) && adjustmentsAreEnabled) {
		return (
			<EnabledFieldDecorator
				// @ts-expect-error - TS2322 - Type 'ComponentType<T>' is not assignable to type 'ComponentType<DecoratedField>'.
				Component={Component}
				componentProps={componentProps}
			/>
		);
	}

	return undecoratedComponent;
};

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const FieldDecoratorAsync = memo(
	FieldDecoratorAsyncNoMemo,
) as typeof FieldDecoratorAsyncNoMemo;

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports, jira/export/restrict-types-re-export
export type { DecoratedField } from './enabled-field-decorator/types';
